import { toCurrency } from '../../utils/formatting';
import Widget from '../Widget';

import CreditLimitProgressBar from './CreditLimitProgressBar';

interface ICreditLimitProps {
  creditLimit: string;
  balance: string;
}

const CreditLimit = ({ creditLimit, balance }: ICreditLimitProps) => {
  // Convert strings to numbers
  const creditLimitNum = parseFloat(creditLimit);
  const balanceNum = parseFloat(balance);

  // Calculate percentage for header display
  // If balance is negative (credit on account), show 0% utilization
  const isNegativeBalance = balanceNum < 0;
  const used = isNegativeBalance ? 0 : Math.abs(balanceNum);
  const percentageUsed = creditLimitNum > 0 ? (used / creditLimitNum) * 100 : 0;
  const roundedPercentage = Math.round(percentageUsed);

  // Use error color for very high utilization (>= 90%), warning for high (>= 80%), success for low
  const isVeryHighUtilization = roundedPercentage >= 90;
  const isHighUtilization = roundedPercentage >= 80;
  const percentageColorClass = isVeryHighUtilization
    ? 'text-error-primary'
    : isHighUtilization
      ? 'text-warning-primary'
      : 'text-success-primary';

  return (
    <Widget>
      <Widget.Header
        title={
          <div className="flex min-w-0 flex-1 flex-wrap items-center gap-x-2">
            <span className="shrink-0">Credit limit:</span>
            <span className="shrink-0">{toCurrency(creditLimitNum)}</span>
            <span className={`shrink-0 text-sm font-medium ${percentageColorClass}`}>({roundedPercentage}% used)</span>
          </div>
        }
      />

      <Widget.Body>
        <CreditLimitProgressBar creditLimit={creditLimitNum} balance={balanceNum} className="p-5" />
      </Widget.Body>
    </Widget>
  );
};

export default CreditLimit;
